<ym-dropdown [showDropdown]="isDropdownOpen" [dismissOnSelect]="!canMultiSelect"
    (onDropdownClose)="toggleDropdown(false)"
    [selectionType]="canMultiSelect? dropdownSelectionTypes.CHECKBOX: dropdownSelectionTypes.CHECKMARK"
    (search)="search($event)" [position]="popoverPositions.BELOW_LEFT_START" [dropdownOption]="filteredDropdownOptions"
    [searchable]="true" (selectedOption)="selectedOption($event)" class="ym-w-full">
    <ng-container trigger>
        <ym-button [variant]="buttonVariants.DROPDOWN" (onClick)="toggleDropdown(true)" [fullWidth]="fullWidth"
            [class.ym-w-full]="fullWidth">{{label}}</ym-button>
    </ng-container>
</ym-dropdown>